import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col d-flex justify-content-center align-items-center mt-md" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_index_button_content = _resolveComponent("index-button-content")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.to)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: _ctx.to,
          class: "text-decoration-none",
          style: {"width":"90%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_index_button_content, {
              text: _ctx.text,
              "underline-text": _ctx.underlineText
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["text", "underline-text"])
          ]),
          _: 3
        }, 8, ["to"]))
      : (_openBlock(), _createElementBlock("a", {
          key: 1,
          href: _ctx.href,
          class: "text-decoration-none",
          style: {"width":"90%"}
        }, [
          _createVNode(_component_index_button_content, {
            text: _ctx.text,
            "underline-text": _ctx.underlineText
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          }, 8, ["text", "underline-text"])
        ], 8, _hoisted_2))
  ]))
}